// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document);
      });
    }
  });
};


/**
 * watchAwaitSelector
 * * Uses mutation observer to watch for 'selector' involved in DOM changes (added, removed, class change, content change, etc)
 * @param {Function} callback A callback function to be run whenever DOM changes are detected, can be anonymous or named
 * @param {String} selector Element(s) to look for involved in DOM changes, you can watch multiple selectors by separating via comma '.class1, .class2, #id3'
 * @param {Node} rootNode Node to watch from, typically document
 * @param {Number} fallbackDelay Interval to be used if the browser does not support MutationObserver, value is in milliseconds (2000 = 2 seconds)
 */
const awaitSelector = (selector, rootNode, fallbackDelay) => new Promise((resolve, reject) => {
  try {
    const root = rootNode || document
    const ObserverClass = MutationObserver || WebKitMutationObserver || null
    const mutationObserverSupported = typeof ObserverClass === 'function'
    let observer
    const stopWatching = () => {
      if (observer) {
        if (mutationObserverSupported) {
          observer.disconnect()
        } else {
          clearInterval(observer)
        }
        observer = null
      }
    }
    const findAndResolveElements = () => {
      const allElements = root.querySelectorAll(selector)
      if (allElements.length === 0) return
      const newElements = []
      const attributeForBypassing = 'data-awaitselector-resolved'
      allElements.forEach((el, i) => {
        if (typeof el[attributeForBypassing] === 'undefined') {
          allElements[i][attributeForBypassing] = ''
          newElements.push(allElements[i])
        }
      })
      if (newElements.length > 0) {
        stopWatching()
        resolve(newElements)
      }
    }
    if (mutationObserverSupported) {
      observer = new ObserverClass(mutationRecords => {
        const nodesWereAdded = mutationRecords.reduce(
          (found, record) => found || (record.addedNodes && record.addedNodes.length > 0),
          false
        )
        if (nodesWereAdded) {
          findAndResolveElements()
        }
      })
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true
      })
    } else {
      observer = setInterval(findAndResolveElements, fallbackDelay || 250)
    }
    findAndResolveElements()
  } catch (exception) {
    reject(exception)
  }
})

const watchAwaitSelector = (callback, selector, rootNode, fallbackDelay) => {
  (function awaiter(continueWatching = true) {
    if (continueWatching === false) return
    awaitSelector(selector, rootNode, fallbackDelay)
      .then(callback)
      .then(awaiter)
  }())
}


function formatCurrencyUSD(amount) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount) + ' USD';
}

function formatCurrency(amount, currency) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(amount) + ' USD';
}

document.ready().then(function () {
  
  const giftBoxID = 30331558527060;
  const $cartCount = document.querySelector('#cartform .CartCount');
  const $cartSubtotal = document.querySelector('#cartform .subtotal .money');
  const $cartTotal = document.querySelector('#cartform .total .money');
  
  fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
  }).then(function (response) {
    return response.json();
  }).then(function (cart) {
    
    console.log("cart is", cart)
    
    watchAwaitSelector($products => {
      console.log("products are", $products);
      

      // Loop through product elements
      for(let i = 0; i < $products.length; i++) {
        
        console.log("i is", i);
        
        // The current product element
        const $product = $products[i];
        
        // The current product cart data
        const product = cart.items[i];
        
        console.log("product is", product);
        console.log("product key is", product.key)
        const productTitle = $product.querySelector('.cart-title h4').textContent.trim();
        
        const $quantity = $product.querySelector('.qty input');
        
        const $remove = $product.querySelector('.remove');
        
        function updateCartQuantityByItemKey(key, quantity, reloadPage = false) {
          const $productCost = $product.querySelector('.item-pricing .money');
          const $productTotal = $product.querySelector('.line-pricing .money');
        
          console.log("called this updateCartQuantityByItemKey");
          let changeFormData = {
            id: key,
            quantity: Number(quantity),
          };
          
          fetch('/cart/change.js', {
            body: JSON.stringify(changeFormData),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },

          }).then(function (response) {
            return response.json();
          }).then(function (json) {
            console.log("json response after change submitted is", json);
            
            // Update the cart values on page
            $cartCount.textContent = json.item_count;
            
            // Reload page to show the "Your Cart Is Empty" layout
            if(json.item_count === 0) {
              location.reload();
            }
            else if(Number(quantity) === 0) {
              
              if($product && $product.parentElement) {
                $product.parentElement.removeChild($product);
              }
              
            }
            else {
              const updatedProduct = json.items.filter(function (obj) {
                if(obj?.key) {
                  return obj.key === product.key;
                }
              })[0];
              
              console.log("product cost is", $productCost);
              
              if($productCost) {
                let currency = $productCost.getAttribute('doubly-currency');
                console.log('product cost is ', $productCost);
                if(currency) {
                  let symbol = $productCost.textContent.charAt(0);
                  let currencyLowercase = currency.toLowerCase();
                  let amount = $productCost.getAttribute(`doubly-currency-${currencyLowercase}`);
                  let ratio = Number(amount) / updatedProduct.final_price;
                  
                  let productCost = updatedProduct.final_line_price * ratio / 100;
                  let subtotal = json.items_subtotal_price * ratio / 100;
                  let total = json.total_price * ratio / 100;
                  
                  $productTotal.textContent = `${symbol}${productCost.toFixed(2)} ${currency}`;
                  $cartSubtotal.textContent = `${symbol}${subtotal.toFixed(2)} ${currency}`;
                  $cartTotal.textContent = `${symbol}${total.toFixed(2)} ${currency}`;
                }
                // Defaulted to USD
                else {
                  $productTotal.textContent = formatCurrencyUSD(updatedProduct.final_line_price / 100);
                  $cartSubtotal.textContent = formatCurrencyUSD(json.items_subtotal_price / 100);
                  $cartTotal.textContent = formatCurrencyUSD(json.total_price / 100);
                }
              } 
              else {
                
              }
            }
            
            if(typeof window.HSSLIDECART !== 'undefined') {
              HsCartDrawer.updateSlideCart();
            }
            
            if(reloadPage === true) {
              location.reload();
            }
            
          }).catch(function (err) {
            console.error(err)
          });
        }
        
        $quantity.addEventListener('change', event => {
          updateCartQuantityByItemKey(product.key, event.target.value);
          
          
          if(Number(event.target.value) <= 0) {
            
            // Find the matching gift box object (if any) for this product
            var giftBox = cart.items.filter(function (obj) {
              if (obj.properties && obj.properties.For) {
                return obj.properties.For === productTitle;
              }
            })[0];
            
            
            if(giftBox) {
              var $giftBox = document.querySelector(`.cart-item[data-key="${giftBox.key}"]`);
            }
            else {
              setTimeout(() => {
                location.reload();
              }, 500);
            }
              
            if(giftBox && $giftBox) {
              
              console.log("giftbox is", giftBox);
              console.log("$giftbox is", $giftBox);
              
              // Remove the giftbox as well
              $giftBox.parentElement.removeChild($giftBox);
              setTimeout(() => {
                updateCartQuantityByItemKey(giftBox.key, 0, true);
              }, 500);
            } 
            
            
          }
        });
        
        
        $remove.addEventListener('click', event => {
          updateCartQuantityByItemKey(product.key, 0);
          
          // Find the matching gift box object (if any) for this product
          var giftBox = cart.items.filter(function (obj) {
            if (obj.properties && obj.properties.For) {
              return obj.properties.For === productTitle;
            }
          })[0];
          
          
          if(giftBox) {
            var $giftBox = document.querySelector(`.cart-item[data-key="${giftBox.key}"]`);
          }
          else {
            setTimeout(() => {
              location.reload();
            }, 500);
          }
          
          console.log(`giftBox for ${productTitle} is`, giftBox, $giftBox);
          
          if(giftBox && $giftBox) {
            console.log("giftbox is", giftBox);
            console.log("$giftbox is", $giftBox);
            
            // Remove the giftbox as well
            $giftBox.parentElement.removeChild($giftBox);
            setTimeout(() => {
              updateCartQuantityByItemKey(giftBox.key, 0, true);
            }, 500);
          }
          
          
          
        });
        
      }
      
    }, '#cartform .cart-item');
  });
  
  
  
  
  
});